import React from 'react';
import {observer} from "mobx-react";
import {action, observable} from "mobx";
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import FlatButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";
import {ErrorComp} from "core/components/errorComp/errorComp";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {fieldStyles} from "core/form/createForm";
import styled from "styled-components";
import SvgEdit = require('react-icons/lib/md/edit');
import SvgDone = require('react-icons/lib/md/done');
import SvgClear = require('react-icons/lib/md/clear');
import SvgCalendar = require('react-icons/lib/fa/calendar-o');
import {formatDateTime, formatTime} from "core/common/utils/dateUtils";
import moment from "moment";
import RadioButtonField from "core/components/fields/radioButtonField";
import {LovItem} from "core/metamodel/mdEntity";
import mdEntityService from "core/metamodel/mdEntityService";

interface ShipmentRequestedTimeProps {
  timeStart: string|Date;
  timeEnd: string|Date;
  changeTimeFn: Function;
  dialogTitle: string;
}

const OpenButtonLineDiv = styled.div`
  display: flex;
  align-items: flex-end;
`;

const minuteOptions = [{value: 15, label: "15 min"}, {value: 35, label: "35 min"}, {value: 60, label: "60 min"}]

/**
 * Pokud je alespon jedna null, zobrazim -> zobrazim minutesValue = 35
 * Pokud j
 */
@observer
export class ShipmentRequestedTime extends React.Component<ShipmentRequestedTimeProps, undefined> {

  @observable private $open: boolean = false;
  @observable private $showCalendar: boolean = false;

  @observable private minutesValue: number;

  private shipmentRequestedTimeDialogRef: ShipmentRequestedTimeDialog;

  shipmentRequestedTimeDialogRefHandler = comp => this.shipmentRequestedTimeDialogRef = comp;

  componentWillMount() {
    const {timeStart, timeEnd} = this.props;
    if (!timeStart || !timeEnd) this.minutesValue = 35;
  }

  @action openTimeEdit = () => {
    console.debug('openTimeEdit');
    this.$open = true;

  };

  @action onChangeStartDate = (value) => {
    console.debug('onChangeStartDate ', value);
    let {timeEnd} = this.props;
    let timeStartM = moment(value).startOf('minute');
    if (value && timeEnd) {
      let durationInMinutes = moment(timeEnd).diff(value, 'minutes');
      let foundOption = minuteOptions.find(o => o.value === durationInMinutes);
      this.minutesValue = (foundOption) ? foundOption.value : 0;
    } else if (value && !timeEnd && this.minutesValue) {
      timeEnd = timeStartM.clone().add(this.minutesValue, 'minutes').toDate();
    }
    this.props.changeTimeFn(timeStartM.toDate(), timeEnd);
  };

  @action onChangeEndDate = (value) => {
    console.debug('onChangeEndDate ', value);
    let {timeStart} = this.props;
    let timeEndM = moment(value).startOf('minute');
    if (value && timeStart) {
      let durationInMinutes = moment(value).diff(timeStart, 'minutes');
      let foundOption = minuteOptions.find(o => o.value === durationInMinutes);
      this.minutesValue = (foundOption) ? foundOption.value : 0;
    } else if (value && !timeStart && this.minutesValue) {
      timeStart = timeEndM.clone().add( - this.minutesValue, 'minutes').toDate();
    }
    this.props.changeTimeFn(timeStart, timeEndM.toDate());
  };

  @action onChangeMinutes = (value: LovItem<number>) => {
    console.debug('onChangeMinutes ', value);
    let {timeStart, timeEnd} = this.props;
    this.minutesValue = (value) ? value.value : 0;
    if (this.minutesValue && timeEnd) {
      let newTimeStart = moment(timeEnd).add( - this.minutesValue, 'minutes').toDate();
      this.props.changeTimeFn(newTimeStart, timeEnd);
    } else if (this.minutesValue && timeStart) {
      let newTimeEnd = moment(timeStart).add( this.minutesValue, 'minutes').toDate();
      this.props.changeTimeFn(timeStart, newTimeEnd);
    }
  };

  render() {
    const {timeStart, timeEnd, dialogTitle} = this.props;

    let sameDay = moment(timeStart).startOf('day').isSame(moment(timeEnd).startOf('day'));
    let endTimeFormated = (sameDay) ? formatTime(timeEnd) : formatDateTime(timeEnd, "L HH:mm");
    let durationInMinutes = moment(timeEnd).diff(timeStart, 'minutes');

    let foundOption = minuteOptions.find(o => o.value === durationInMinutes);



    let openContent = (
      <div style={{display: 'flex', alignItems: 'baseline', flexDirection: 'column'}}>
        <RadioButtonField name="minutesRbf" options={minuteOptions} value={this.minutesValue}  onChange={this.onChangeMinutes}  {...fieldStyles.small.radioButton} groupStyle={{display: 'flex', flexWrap: 'wrap'}}
                          optionStyle={{width: 'initial', marginRight: 5}}
                          labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}/>
        <StyledDatePicker  value={this.props.timeStart} onChange={this.onChangeStartDate} time
                           floatingLabelText="Start time"  {...fieldStyles.small.textField} />
        <StyledDatePicker  value={this.props.timeEnd} onChange={this.onChangeEndDate} time
                           floatingLabelText="End time"  {...fieldStyles.small.textField} />
      </div>
    )



    console.debug("render: timeStart " + timeStart + ", timeEnd " + timeEnd + ", durationInMinutes " + durationInMinutes);


    let closedContent = (
      <div>
        <span>{formatDateTime(timeStart, "L HH:mm")} - {endTimeFormated}  </span>
        {(durationInMinutes != 0) && (<span> ({durationInMinutes} min)</span>) }
      </div>
    );

    return (this.$open) ? (
      <div className="active-item--open">
        <ShipmentRequestedTimeDialog title={dialogTitle} ref={this.shipmentRequestedTimeDialogRefHandler} entities={mdEntityService.entityMap} />
        {openContent}

        <OpenButtonLineDiv>
          <SvgDone className="active-item--check  zz-mr-15" size={24} onClick={this.onCommit}/>
          <SvgClear className="active-item--check" size={24} onClick={this.onRollback}/>
          <SvgCalendar className="active-item--check" size={18} onClick={this.onCalendar}/>
        </OpenButtonLineDiv>

      </div>
    ) : (
      <div className='active-item--closed' style={{paddingLeft: 0, paddingTop: 0}}>
        <ShipmentRequestedTimeDialog title={dialogTitle} ref={this.shipmentRequestedTimeDialogRefHandler} entities={mdEntityService.entityMap} />
        {closedContent}
        <div className="active-item--action-group">
          <SvgEdit className="active-item--action" onClick={this.openTimeEdit}/>
        </div>
      </div>
    );

  }

  @action onCommit = (evt) => {
    this.$open = false;
  };

  @action onRollback = (evt) => {
    this.$open = false;
  };

  @action onCalendar = (evt) => {
    new Promise((resolve, reject) => {
      this.shipmentRequestedTimeDialogRef.open(resolve, reject);
    }).then((res) => {
      //grid.search(null);
    })
      .catch((error) => {
        console.log('rejecting ShipmentUpdateDialog with ', error);
      });

  };

}

interface ShipmentRequestedTimeDialogProps extends DialogProps {
  title: string;
}

@observer
class ShipmentRequestedTimeDialog extends DialogAncestor<ShipmentRequestedTimeDialogProps, undefined, string> {



  @action open(resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
    this.$errors = [];
    this.dialogOpen = true;
  }



  @action ok = () => {
    this.$errors = [];

    if (this.hasErrors()) {
      return;
    }

    this.dialogOpen = false;
    this.resolve("ok");
  };

  @action cancel = (evt) => {
    this.dialogOpen = false;
    this.$errors = [];
    this.reject("cancel");
  };


  render() {

    if (!(this.dialogOpen)) return null;


    const actions = [
      <FlatButton key={1}
        label="Cancel"
        primary
        onClick={this.cancel}
      />,
      <FlatButton key={2}
        label="Ok"
        secondary
        onClick={this.ok}
      />
    ];

    return (
      <Dialog
        title={this.props.title}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        autoScrollBodyContent={true}
        contentStyle={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', filter: 'blur(0)'}}
        bodyStyle={{minHeight: 600}}
      >
        <ErrorComp messages={this.$errors}/>

        <div>
          <iframe id="inlineFrameExample"
                  width="700"
                  height="600"
                  src="/fe2/test-calendar2" style={{border: "0"}}/>
        </div>

      </Dialog>
    );
  }


}



// WEBPACK FOOTER //
// ./src/shipment/component/shipmentRequestedTime.tsx